import React from "react";
import { Table, Popover, OverlayTrigger, Form, Col, Row } from "react-bootstrap";
import PersonListRenderer from "./renderers/PersonListRenderer";
import HistoricAdminsPopoverView from "./HistoricAdminsPopoverView";

interface DegreeInformationTableViewProps
{
    data: UltimateDegrees;
}

interface DegreeInformationTableViewState
{
    popOverData: Person[];
    openPrimaryAdmins: boolean;
    openSecondaryAdmins: boolean;
}

export default class DegreeInformationTableView extends React.Component<DegreeInformationTableViewProps, DegreeInformationTableViewState>
{
    constructor(props: DegreeInformationTableViewProps)
    {
        super(props);

        this.state = {
            popOverData: [],
            openPrimaryAdmins: false,
            openSecondaryAdmins: false
        };
    }

    render(): React.ReactNode
    {
        let pmCurrent = this.props.data.primaryMajorsAcademicAdmins;
        let smCurrent = this.props.data.secondaryMajorsAcademicAdmins;
        let pmHistoric = this.props.data.primaryMajorsAcademicAdmins;
        let smHistoric = this.props.data.secondaryMajorsAcademicAdmins;

        if (this.props.data.primaryMajorsAcademicAdmins && this.props.data.primaryMajorsAcademicAdmins.length > 0)
        {
            pmCurrent = this.props.data.primaryMajorsAcademicAdmins.filter(itm => itm.isCurrent);
            pmHistoric = this.props.data.primaryMajorsAcademicAdmins.filter(itm => !itm.isCurrent);
        }

        if (this.props.data.secondaryMajorsAcademicAdmins && this.props.data.secondaryMajorsAcademicAdmins.length > 0)
        {
            smCurrent = this.props.data.secondaryMajorsAcademicAdmins.filter(itm => itm.isCurrent);
            smHistoric = this.props.data.secondaryMajorsAcademicAdmins.filter(itm => !itm.isCurrent);
        }

        const popover = (data: Person[]) =>
        {
            return <Popover id="popover-basic" className="popover">
                <Popover.Content>
                    <HistoricAdminsPopoverView data={data} />
                </Popover.Content>
            </Popover>;
        };

        return <Form>
            <Form.Group as={Row}>
                <Form.Label className="grayText" column md="5">
                    Ultimate Degree
                            </Form.Label>
                <Col md="7">
                    <Form.Control plaintext as={"div"}>
                        <b>{this.props.data.ultimateDegree ? this.props.data.ultimateDegree : " - "}</b>
                    </Form.Control>
                </Col>
            </Form.Group>
            <Form.Group as={Row}>
                <Form.Label className="grayText" column md="5">
                    Primary Major
                            </Form.Label>
                <Col md="7">
                    <Form.Control plaintext as={"div"}>
                        <b>{this.props.data.primaryMajor ? this.props.data.primaryMajor : " - "}</b>
                    </Form.Control>
                </Col>
            </Form.Group>
            {
                this.props.data.primaryMajorsAcademicAdmins
                &&
                <Form.Group as={Row}>
                    <Form.Label className="grayText" column md="5">
                        Major Academic Admin
                            </Form.Label>
                    <Col md="7">
                        <Form.Control plaintext as={"div"}>
                            <Row>
                                <Col>
                                    <PersonListRenderer admins={true} value={pmCurrent} />
                                </Col>
                                {
                                    pmHistoric.length > 0
                                    &&
                                    <OverlayTrigger trigger="click" placement="bottom" overlay={popover(pmHistoric)}>
                                        <Col xs={2} onClick={() => this.setState({ openPrimaryAdmins: !this.state.openPrimaryAdmins })}>
                                            <i className={this.state.openPrimaryAdmins ? "far fa-chevron-up" : "far fa-chevron-down"}></i>
                                        </Col>
                                    </OverlayTrigger>
                                }
                            </Row>
                        </Form.Control>
                    </Col>
                </Form.Group>
            }
            {
                this.props.data.secondaryMajor
                &&
                <Form.Group as={Row}>
                    <Form.Label className="grayText" column md="5">
                        Secondary Major
                            </Form.Label>
                    <Col md="7">
                        <Form.Control plaintext as={"div"}>
                            <b>{this.props.data.secondaryMajor ? this.props.data.secondaryMajor : " - "}</b>
                        </Form.Control>
                    </Col>
                </Form.Group>
            }
            {
                this.props.data.secondaryMajorsAcademicAdmins
                &&
                <Form.Group as={Row}>
                    <Form.Label className="grayText" column md="5">
                        Secondary Major Academic Admin
                            </Form.Label>
                    <Col md="7">
                        <Form.Control plaintext as={"div"}>
                            <Row>
                                <Col>
                                    <PersonListRenderer admins={true} value={smCurrent} />
                                </Col>
                                {
                                    smHistoric.length > 0
                                    &&
                                    <OverlayTrigger trigger="click" placement="bottom" overlay={popover(smHistoric)}>
                                        <Col xs={2} onClick={() => this.setState({ openSecondaryAdmins: !this.state.openSecondaryAdmins })}>
                                            <i className={this.state.openSecondaryAdmins ? "far fa-chevron-up" : "far fa-chevron-down"}></i>
                                        </Col>
                                    </OverlayTrigger>
                                }
                            </Row>
                        </Form.Control>
                    </Col>
                </Form.Group>
            }
        </Form>;
    }
}